import { render, staticRenderFns } from "./HDivider.vue?vue&type=template&id=72625f70&scoped=true"
import script from "./HDivider.vue?vue&type=script&lang=js"
export * from "./HDivider.vue?vue&type=script&lang=js"
import style0 from "./HDivider.vue?vue&type=style&index=0&id=72625f70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72625f70",
  null
  
)

export default component.exports